import React from "react";
import { Paper, Box, Typography, Chip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

const ClienteCard = ({ datosformulario, consumidorFinal, toggleConsumidorFinal }) => {
  const esConsumidorFinal = consumidorFinal === 1;
  const puedeCambiar = datosformulario.factura_consfinal === 1;
  const tieneCuit = datosformulario.cuit && datosformulario.cuit.trim() !== "";

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1,
        cursor: puedeCambiar ? "pointer" : "default",
        bgcolor: esConsumidorFinal ? "#f0f9ff" : "#fafafa",
        border: `1px solid ${esConsumidorFinal ? "#4dabf5" : "#e0e0e0"}`,
        borderRadius: 1,
        transition: "all 0.15s",
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        '&:hover': puedeCambiar ? {
          bgcolor: esConsumidorFinal ? "#e6f4ff" : "#f5f5f5",
          borderColor: esConsumidorFinal ? "#2196f3" : "#bdbdbd"
        } : {},
      }}
      onClick={toggleConsumidorFinal}
    >
      {/* Header compacto */}
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <PersonIcon fontSize="small" sx={{ color: esConsumidorFinal ? "#2196f3" : "#757575", fontSize: 16 }} />
          <Typography variant="caption" fontWeight="bold" color="text.secondary">
            CLIENTE
          </Typography>
        </Box>
        
        {puedeCambiar && esConsumidorFinal && (
          <Chip
            label="Cons. Final"
            size="small"
            color="primary"
            variant="filled"
            sx={{ 
              fontSize: '0.6rem',
              height: 18,
              minWidth: 32,
              fontWeight: 'bold',
              '& .MuiChip-label': { px: 0.5 }
            }}
          />
        )}
      </Box>

      {/* Nombre del cliente */}
      <Typography 
        variant="body2" 
        fontWeight="500"
        sx={{ 
          color: esConsumidorFinal ? "#1565c0" : "text.primary",
          lineHeight: 1.2,
          mb: 1,
          flexGrow: 1,
          fontSize: '0.8rem'
        }}
      >
        {datosformulario.cliente}
      </Typography>

      {/* Información compacta */}
      <Box>
        <Typography variant="caption" color="text.secondary" display="block" mb={0.3}>
          {datosformulario.direccion_entrega}
        </Typography>
        
        {/* {tieneCuit && (
          <Typography variant="caption" color="text.secondary" fontFamily="monospace">
            {datosformulario.cuit}
          </Typography>
        )} */}
      </Box>

      {/* Indicador de cambio */}
      {puedeCambiar && (
        <Box display="flex" alignItems="center" justifyContent="flex-end" mt={0.5} pt={0.5} sx={{ borderTop: '1px dashed #e0e0e0' }}>
          <Box display="flex" alignItems="center" gap={0.3}>
            <SwapHorizIcon sx={{ fontSize: 12, color: "#757575" }} />
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
              Cambiar
            </Typography>
          </Box>
        </Box>
      )}
    </Paper>
  );
};

export default ClienteCard;